// extracted by mini-css-extract-plugin
export default {"startScreen":"startpage_startScreen__itRI2","horizontalButtonsContainer":"startpage_horizontalButtonsContainer__vhiWn"};